import glamorous from "glamorous";

export const Container = glamorous.div({
  marginLeft: "0px",
  marginRight: "0px",
  padding: "0",
  display: "inline-block",
  position: "relative",
  width: "100%",
  boxSizing: "border-box",
  backgroundColor: "rgb(255, 255, 255)",
});

export const SearchInput = glamorous.input({
  paddingTop: "20px",
  paddingBottom: "20px",
  paddingLeft: "12px",
  paddingRight: "0px",
  marginLeft: "0px",
  marginRight: "0px",
  marginBottom: "30px",
  height: "20px",
  width: "calc(100% - 42px)",
  color: "rgb(51, 51, 51)",
  fontSize: "18px",
  boxSizing: "border-box",
  border: "1px solid rgb(194, 194, 194)",
  borderRight: "0px solid rgb(194, 194, 194)",
  display: "inline-block",
  verticalAlign: "top",
  ":focus": {
    outline: "none",
    border: "1px solid rgb(194, 194, 194)",
    borderRight: "0px solid rgb(194, 194, 194)",
  },
});

export const SearchInputBtn = glamorous.span({
  marginLeft: "0px",
  marginRight: "0px",
  height: "42px",
  paddingRight: "12px",
  width: "42px",
  color: "rgb(194, 194, 194)",
  fontSize: "18px",
  boxSizing: "border-box",
  border: "1px solid rgb(194, 194, 194)",
  borderLeft: "0px solid rgb(194, 194, 194)",
  display: "inline-block",
  cursor: "pointer",
  lineHeight: "42px",
  ":focus": {
    outline: "none",
  },
  ":before": {
    float: "right",
    fontSize: "16px",
    fontFamily: "jd_icon !important",
    content: "\\E90F",
  },
});

export const PrimaryInput = glamorous.input(({ isActive }) => ({
  width: "100%",
  display: isActive === true ? "block" : "none",
  fontFamily: "jd_sans_probold",
  color: "rgb(51, 51, 51)",
  fontSize: "18px",
  lineHeight: "66px",
  textDecoration: "none",
  position: "relative",
  backgroundColor: "transparent",
  boxSizing: "border-box",
  border: "none",
  paddingTop: "0",
  paddingBottom: "0",
  ":focus": {
    outline: "none",
    border: "none",
  },
  "@media screen and (min-width: 1025px)": {
    display: "none",
  },
}));

export const Attributes = glamorous.ul({
  padding: "0",
  display: "inline-block",
  width: "100%",
  verticalAlign: "top",
  "@media screen and (min-width: 1025px)": {
    width: "45%",
  },
});

export const Attribute = glamorous.li({
  width: "100%",
  display: "block",
  listStyle: "none",
  "@media screen and (min-width: 1025px)": {},
});

export const DateTierOne = glamorous.ul(({ isActive }) => ({
  width: "100%",
  background: "rgb(255, 255, 255)",
  margin: "0",
  padding: "0",
  position: "relative",
  overflow: isActive === true ? "visible" : "hidden",
  lineHeight: "26px",
  boxSizing: "border-box",
  height: isActive === true ? "auto" : "57px",
  borderBottom: "1px solid rgb(194, 194, 194)",
  "@media screen and (min-width: 1025px)": {
    height: "auto",
    overflow: "visible",
    borderBottom: "none",
  },
}));
